<template>
  <b-modal :id="id"
           lazy
           centered
           ok-variant="ls"
           size="lg"
           :title="$t('Enable notifications')"
           :cancel-title="$t('No Thanks')"
           footer-class="justify-content-between"
           :ok-title="$t('Enable notifications')"
           @ok="handleOk"
           @cancel="neverShowAgain"
           hide-header
           no-stacking
  >
    <div class="text-center mt-3">
      <h3>{{$t('Enable notifications title')}}</h3>
    </div>
  </b-modal>
</template>

<script>
import {mapState} from "vuex";
import { getFirebaseMessaging, getFirebaseProjectId } from "@/utils/FirebaseCloudMessaging";
import {getToken} from "firebase/messaging";
import {isIosApp, detectAppType, detectOs, detectBrowser} from "@/utils/Pwa";

export default {
  name: "NotificationsPermissionModal",
  data() {
    return {
      id: 'notifications-permission-modal',
      token: '',
      tokenExists: false,
    }
  },
  mounted() {
    if (!this.isAuthorized ||  !this.push.enabled || this.dismissModal) {
      return;
    }
    let tokenFromStorage = localStorage.getItem('ls-fcm-token');
    if (("Notification" in window)) {
      if (Notification.permission === 'granted') {
        this.getMessagingToken()
            .then(token => this.checkTokenExists(token))
            .then((tokenExists) => {
              if (!tokenExists) {
                this.$bvModal.show(this.id);
              }
            });
        return;
      }

      if (Notification.permission === "denied") {
        return; // user denied notifications
      }
      setTimeout(() => this.$bvModal.show(this.id), 1000);
    }else if(!tokenFromStorage){  //todo tylko na ios?
      return;
    }

    if(isIosApp && tokenFromStorage){
      this.getMessagingToken()
          .then(token => this.checkTokenExists(token))
          .then((tokenExists) => {
            if (!tokenExists) {
              this.createPushToken(tokenFromStorage);
            }
          });
    }
  },
  methods: {
    handleOk() {
      if (this.tokenExists) {
        this.createPushToken(this.token);
      } else {
        this.requestPermission();
      }
    },
    requestPermission() {
      if (!this.isAuthorized) {
        return;
      }
      if (("Notification" in window)) {
        Notification.requestPermission()
            .then(permission => {
              if (permission !== 'granted') {
                return;
              }

              this.getMessagingToken().then(token => this.createPushToken(token)).then(() => localStorage.setItem(this.pushTokenExistsStorageKey, true));
            });
      }else if(isIosApp){  //todo check if ios and permissions are granted from ios
        this.getMessagingToken().then(token => this.createPushToken(token)).then(() => localStorage.setItem(this.pushTokenExistsStorageKey, true));
      }
    },
    async getMessagingToken() {
      if (isIosApp && localStorage.getItem('ls-fcm-token')) {
        let token = localStorage.getItem('ls-fcm-token');
        this.token = token;
        return token;
      }

      const messaging = await getFirebaseMessaging();
      if (!messaging) {
        throw new Error('No Messaging API');
      }

      try {
        const token = await getToken(messaging);
        this.token = token;
        return token;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('[push] getToken failed:', e);
        return null;
      }
    },
    checkTokenExists(token) {
      if (!token) {
        return;
      }

      return this.$http.post('/push/token/exists', {token})
          .then(r => {
            // Backend tells us whether a refresh POST is actually needed —
            // covers both rebind (userMatch=false) and natural-backfill of
            // metadata columns added in V30.0.5. When row is already complete
            // and bound to current user, skip the POST (saves one roundtrip
            // per page load).
            if (r.data.success && r.data.needsUpdate) {
              this.createPushToken(token, true);
            }
            this.tokenExists = r.data.success
            // eslint-disable-next-line no-console
            localStorage.setItem(this.pushTokenExistsStorageKey, !!r.data.success);
            return this.tokenExists;
          });
    },
    createPushToken(token,hideMessage = false) {
      // Pełna mapa pól w docs/development/push_token_origins.md.
      // platform = SDK rejestrujący token (FCM web vs Firebase iOS SDK)
      // appType  = kanał dystrybucji (browser/pwa/store) — diagnostyczne
      // os       = system operacyjny urządzenia — diagnostyczne
      // browser  = vendor przeglądarki gdy appType='browser' — diagnostyczne
      // firebaseProjectId = identyfikator projektu Firebase — driver wyboru SA
      const platform = isIosApp ? 'ios' : 'web';
      return this.$http.post('push/token', {
        token,
        hideMessage,
        platform,
        mkVersion: 'mk1',
        appType: detectAppType(),
        os: detectOs(),
        browser: detectBrowser(),
        firebaseProjectId: getFirebaseProjectId(),
      });
    },
    neverShowAgain() {
      localStorage.setItem(this.dismissStorageKey, true);
    },
  },
  computed: {
    ...mapState({
      entityUuid: state => state.auth.entity.uuid,
      isAuthorized: state => state.auth.isAuthorized,
      push: state => state.settings.push
    }),
    dismissStorageKey() {
      return `ls-dismiss-notifications-${this.entityUuid}`;
    },
    pushTokenExistsStorageKey() {
      return `ls-push-token-${this.entityUuid}`;
    },
    dismissModal() {
      return localStorage.getItem(this.dismissStorageKey) === 'true';
    },
  }
}
</script>

<style scoped>

</style>
